import { ReactNode } from 'react';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { loginRequest } from './msalConfig';
import { Shield, LogIn } from 'lucide-react';

interface AuthGuardProps {
  children: ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const isAuthenticated = useIsAuthenticated();
  const { instance, inProgress } = useMsal();

  if (inProgress === InteractionStatus.Login || inProgress === InteractionStatus.HandleRedirect) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-950">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-500 mx-auto mb-4" />
          <p className="text-gray-500 dark:text-gray-400">Signing in...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-950">
        <div className="card max-w-sm w-full mx-4 text-center">
          <div className="flex justify-center mb-6">
            <div className="p-4 bg-brand-100 dark:bg-brand-900/50 rounded-2xl">
              <Shield className="h-12 w-12 text-brand-600 dark:text-brand-400" />
            </div>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">Credentium</h1>
          <button
            onClick={() => instance.loginRedirect(loginRequest)}
            className="btn-primary w-full flex items-center justify-center gap-2"
          >
            <LogIn className="h-5 w-5" />
            Sign in
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
